import React, { useContext, useEffect, useRef, useState } from 'react'
import Slider from "react-slick";

import EstimatePayment from './components/EstimatePayment';
import ApplyFinancing from './components/ApplyFinancing';

import { ModalVehicleContext } from '../storage/VehicleContext';
import FinanceCalculator from "../../../Modules/financeCalculator"
import useRenderizable from '../hooks/useVehicleContextValidator';
import { captureEvent } from 'event-service/modules/capture'
import "../../contact/ContactForm.scss"
import view from "./calculator.module.scss"
import iconArrow from "../../img/icon-arrow.svg"

export default function CalculatorModal(props) {
  const [context] = useContext(ModalVehicleContext)
  const { finalPrice, vehicleInfo } = props.contextualized ? context : props
  const { defaultMonth, downpayment, rates } = props

  const slider = useRef(null)
  const [slide, setSlide] = useState(0)
  const [page, setPage] = useState(0)
  const [state, setState] = useState({
    months: 0, rate: 0, tradein: 0,
    downpayment: finalPrice * downpayment / 100,
    percentage: downpayment
  })
  const [payments, setPayments] = useState([])
  const [estimated, setEstiamted] = useState(0)
  const [disclaimer, setDisclaimer] = useState(false)
  const [engagement, setEngagement] = useState(false)

  useEffect(() => {
    if (engagement) {
      captureEvent({
        event: 'asc_form_engagement',
        comm_type: 'form',
        comm_status: 'start',
        element_text: engagement?.innerText,
        department: 'sales',
        form_name: 'Financing Calculator',
        form_type: 'sales',
        item_id:  vehicleInfo.VIN,
        item_number: `${vehicleInfo.Year} ${vehicleInfo.Make} ${vehicleInfo.Model} ${vehicleInfo.Trim}`,
        item_price: `${finalPrice}`,
        item_condition: `${vehicleInfo.IsNew ? 'New' : 'Used'}`,
        item_year: vehicleInfo.Year,
        item_make: vehicleInfo.Make,
        item_model: vehicleInfo.Model,
        item_variant: vehicleInfo.Trim,
        item_color: vehicleInfo.ExteriorColor,
        item_type:'vehicle',
        item_category: vehicleInfo.BodyType,
        item_fuel_type: vehicleInfo.EngineFuelType,
        item_inventory_date: vehicleInfo.InStockDate,
      }, {
        handlers: ['ASC']
      }).then(res => console.log(res)).catch(err => console.log(err))
    }
  }, [engagement])

  const months = [12, 24, 36, 48, 60, 72]
  const calculator = new FinanceCalculator()

  const requiredFields = ["VIN", "StockNumber", "Year", "Make", "Model", "Trim"]
  const isRenderizable = useRenderizable({ finalPrice, vehicleInfo }, requiredFields)

  //onMount: go to default month slide
  useEffect(() => {
    setTimeout(() => {
      if (isRenderizable && slider.current) {
        const index = months.indexOf(defaultMonth)
        slider.current.slickGoTo(index)
          updateState(index, "months")
          setSlide(index)
      }
    },200);
  }, [isRenderizable])

  useEffect(() => {
    const toFinance = finalPrice - (finalPrice * (state.percentage) / 100) - state.tradein
    if (!isNaN(toFinance) && isFinite(toFinance)) {
      setEstiamted(toFinance)
    } else {
      return
    }

    const payments = months.map(month => {
      const payment = calculator.calculateMonthlyPayment(
        finalPrice - state.tradein, 0, 0, month, rates[state.rate], state.percentage
      )
      return parseFloat(payment)
    })
    const calculable = payments.some(value => isFinite(value) || !isNaN(value) || value === 0)
    if (calculable) {
      setPayments(payments)
    }
  }, [state.tradein, state.rate, state.percentage])

  const updateState = (value, name) => {
    setState({ ...state, [name]: value })
  }

  const nextPage = () => {
    const _page = (page + 1) % renderForm.length
    setPage(_page)
  }

  const renderPrice = (payment, month, idx) => (
    <div className={`${view["financing"]} ${slide == idx && view["active"]}`}>
      <h1 className={slide == idx ? view["finalPrice-focus"] : view["finalPrice"]}>
        {`$${FinanceCalculator.formatLocale(payment)}`}
      </h1>
      <span className={view["monthly"]}>/mo</span>
      <p className={view["months"]}>{`${month} months`}</p>
    </div>
  )

  const renderArrow = () => (
    <div className={view["arrows"]} onClick={() => setEngagement({innerText: "Carousel Arrows"})}>
      <p onClick={() => slider.current.slickPrev()}>
        &#10094;
      </p>
      <p onClick={() => slider.current.slickNext()}>
        &#10095;
      </p>
    </div>
  )

  const settings = {
    centerMode: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    afterChange: i => {
      updateState(i, "months")
      setSlide(i)
    },
    customPaging: i => (
      <div className={`
        ${view["pager-dots"]} 
        ${slide == i && view["pager-active"]}`} />
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  }

  const renderForm = [
    <EstimatePayment vehicleInfo={vehicleInfo} price={finalPrice} months={months} month={state.months} percentage={state.percentage}
      values={state} setValues={setState} slider={slider} nextPage={nextPage} />,
    <ApplyFinancing gtmId={props.gtmId} leadURL={props.leadURL} siteId={props.siteId} pageSource={"FinanceApp"}
      nextPage={nextPage} vehicleInfo={vehicleInfo} finalPrice={finalPrice} pageURL={document.URL}
      callForPrice={finalPrice > 0}
      extraData={{
        months: months[state.months], rate: rates[state.rate],
        monthly: payments[state.months],
        tradein: state.tradein, downpayment: state.downpayment
      }}
    />
  ]

  return (
    isRenderizable &&
    <div style={{ width: '100%' }}>
      {
        finalPrice > 0 && (
          <section className={`contact-formCont ${view["slider-wrap"]}`}>
            <Slider {...settings} ref={slider}>
              {
                months.map((month, idx) => {
                  const payment = payments[idx]
                  return renderPrice(payment, month, idx)
                })
              }
            </Slider>
            {page == 0 && renderArrow()}
          </section>
        )
      }

      {finalPrice > 0 ? renderForm[page] : renderForm[1]}

      <hr />

      {
        finalPrice > 0 && (
          <section className={view["payment-detail"]}>
            <h1>PAYMENT DETAIL</h1>
            <h4>ESTIMATED AMOUNT FINANCED</h4>
            <h2 className={view["financed-amount"]}>
              {`$${FinanceCalculator.formatLocale(estimated)}`}
            </h2>
          </section>
        )
      }

      <section className={view["disclaimer-wrap"]}>
        <p className={view["disclaimer-title"]} onClick={() => setDisclaimer(!disclaimer)}>
          Disclaimer
          <img className={view[disclaimer && "caret-active"]} src={iconArrow} />
        </p>
        {disclaimer &&
          <div className={view["disclaimer"]}
            dangerouslySetInnerHTML={{ __html: props.disclaimerCalculator }} />
        }
      </section>
    </div>
  )
}

CalculatorModal.defaultProps = {
  siteId: "",
  leadURL: "",
  finalPrice: 100000,
  defaultMonth: 12,
  downpayment: 50,
  rates: [1, 2, 3, 4, 5, 6],
  disclaimerCalculator: <p></p>,
  vehicle: {},
  finalPrice: 0,
  vehicleInfo: {}
}